/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import ErrorScreen from "../../shared-ui/errors/error-screen";
import { utag, withUtag } from "../../analytics/analytics";
import {
  getUtagAuthObject,
  getUtagNeedStates,
  getUtagSessionObject,
} from "../../../utils/utagSession";
import _ from "lodash";

// Interface for FoodDetails State
interface FoodDetailsState {
  data: any;
}

/**
 * FoodDetails component.
 *
 * @namespace FoodDetails
 */
class FoodDetails extends React.Component<any, FoodDetailsState> {
  constructor(props: any) {
    super(props);
    this.state = {
      data: "",
    };
  }

  componentWillReceiveProps(props: any) {
    //update to analytics
    let authObj = getUtagAuthObject();
    let sessionObj = getUtagSessionObject();
    let needStatesObj = getUtagNeedStates();
    let obj = {
      page_name: window.location.pathname.includes("summary")
        ? "My Foods"
        : "My Results",
      event_name: "wellness_details",
      wellness_contentID: props?.foodsData?.data?.lookup_id,
      wellness_contentName: props?.foodsData?.data?.food_title,
      wellness_contentType:
        props.selectedOption === "recipe" ? "food_recipe" : "food_why",
      ...(window.location.pathname.includes("summary") && {
        wellness_filter:
          props.hitStateSubType === "eat" ? "what-to-eat" : "what-to-avoid",
      }),
    };
    let updatedObj = _.merge(
      localStorage.getItem("user-info") ? authObj : {},
      localStorage.getObj("reco-result") ? needStatesObj : {},
      sessionObj,
      obj
    );
    withUtag().then((utag) => utag.view(updatedObj));
  }

  componentDidUpdate = () => {
    if (this.props?.foodsData !== this.state.data) {
      let hashValues = _.split(window.location.hash, "/#");
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}${hashValues[0]}`
      );

      let updatedHashValues = _.split(window.location.hash, "/#");
      window.history.replaceState(
        null,
        "",

        updatedHashValues.length === 1
          ? `${window.location.href}/#${this.props?.foodsData?.data?.lookup_id}`
          : `${window.location.pathname}${updatedHashValues[0]}/#${
              updatedHashValues[updatedHashValues.length - 1]
            }`
      );
      this.setState({ data: this.props.foodsData });
    }
  };
  render() {
    const { selectedOption, foodsData, hitStateSubType } = this.props;
    return (
      <>
        {/* Recipe Section Start */}
        {selectedOption &&
          selectedOption === "recipe" &&
          (hitStateSubType &&
          hitStateSubType === "eat" &&
          foodsData &&
          foodsData?.recipes ? (
            <div className="details-area">
              <div className="recipe-name-wrapper">
                {/* <div className="name">Creamed Greens</div> */}
                <div className="name">{foodsData?.recipes?.name}</div>
                <div className="time">
                  {foodsData?.recipes?.totalTime} |{" "}
                  {foodsData?.recipes?.numberOfServings}{" "}
                  {foodsData?.recipes?.numberOfServings === 1
                    ? this.props.t("common.serving")
                    : this.props.t("common.servings")}
                </div>
              </div>
              {/* ingreadients section Start */}
              <div className="ingredients-wrapper">
                <div className="total-ingreadients">
                  {this.props.t("common.ingredients")} (
                  {foodsData?.recipes?.ingredientLines?.length})
                </div>
                <div className="ingreadients-area">
                  {foodsData?.recipes?.ingredientLines?.length > 0 &&
                    foodsData?.recipes?.ingredientLines?.map((item: any) => (
                      <div className="ingreadient">
                        <span className="name">{item}</span>
                        {/* <span className="quantity">2 tbsp</span> */}
                      </div>
                    ))}
                  {/* <div className="ingreadient">
                  <span className="name">Lemon juice</span>
                  <span className="quantity">2 tbsp</span>
                </div>
                <div className="ingreadient">
                  <span className="name">Lemon juice</span>
                  <span className="quantity">2 tbsp</span>
                </div>
                <div className="ingreadient">
                  <span className="name">Lemon juice</span>
                  <span className="quantity">2 tbsp</span>
                </div> */}
                </div>
              </div>
              {/* ingreadients section Ends */}

              {/* instructions section Start */}
              <div className="instructions-wrapper">
                <div className="instruction-label">
                  {" "}
                  {this.props.t("common.instructions")}
                </div>
                <div className="instructions-area">
                  <ul>
                    {foodsData?.recipes?.instructions &&
                      foodsData?.recipes?.instructions?.length > 0 &&
                      foodsData?.recipes?.instructions?.map((item: any) => (
                        <li className="instruction">
                          {item}
                          {/* Heat 2 tablespoons of the oil in a frying pan and sauté the
                    greens over a medium–high heat until tender. Remove to a
                    bowl. */}
                        </li>
                      ))}

                    {/* <li className="instruction">
                    Heat 2 tablespoons of the oil in a frying pan and sauté the
                    greens over a medium–high heat until tender. Remove to a
                    bowl.
                  </li>
                  <li className="instruction">
                    Heat 2 tablespoons of the oil in a frying pan and sauté the
                    greens over a medium–high heat until tender. Remove to a
                    bowl.
                  </li> */}
                  </ul>
                </div>
              </div>
              {/* instructions section Ends */}
            </div>
          ) : (
            <>
              <ErrorScreen
                errorTitle={this.props.t("error.no_recipe_message_title")}
                errorDetails={this.props.t("error.no_recipe_message")}
              />
            </>
          ))}

        {/* Recipe Section Ends */}

        {/* Why Section Start */}
        {selectedOption && selectedOption === "why" && (
          <div className="details-area">
            <div className="food-details">
              {foodsData?.data?.why_content}
              {/* Green leafy vegetables are supercharged with vitamins and minerals
              – and antioxidants and beta carotene, too. All combined, these
              nutrients build up the natural immune response to infections and
              disease. */}
            </div>
          </div>
        )}
        {/* Why Section Ends */}
      </>
    );
  }
}

export default FoodDetails;
